import BrowserOutdatedMessage from './BrowserOutdatedMessage'

export default BrowserOutdatedMessage



// WEBPACK FOOTER //
// ./src/legacy/components/BrowserOutdatedMessage/index.js